export const jobCodes = {
    0: {
        // MT
        id: 0,
        jobCode: 'US-KEY-10706 08/26',
    },
    // 1: {
    //     // HCC
    //     id: 1,
    //     jobCode: 'US-PDO-01572 01/22',
    // },
    2: {
        // MEL
        id: 2,
        jobCode: 'US-OOC-03019 12/25',
    },
    // 3: {
    //     // MEL - Adjuvant
    //     id: 3,
    //     jobCode: 'US-OOC-01141  05/21',
    // },
    4: {
        // ALL LUNG / NSCLC
        id: 4,
        jobCode: 'US-LAS-00039 03/26',
    },
    5: {

    },
    6: {

    },
    7: {

    },
    8: {
        // RCC (adjuvant)
        id: 8,
        jobCode: 'US-RCS-00068 09/26',
    },
    9: {
        // HNSCC
        id: 9,
        jobCode: 'US-OHN-02008 10/24',
    },
    10: {
        // 1L Mono HNSCC
        id: 10,
        jobCode: '',
    },
    11: {
        // 2L Mono HNSCC
        id: 11,
        jobCode: '',
    },
    // 12 is missing since the ids were duplicated from indications.js
    13: {
        // cSCC
        id: 13,
        jobCode: 'US-OHC-00384 12/25',
    },
    14: {
        // MCC
        id: 14,
        jobCode: 'US-PDO-02591 12/25',
    },
    15: {
        // UC
        id: 15,
        jobCode: 'US-OBD-02338 03/26',
    },
    16: {
        // id: 16,
        // jobCode: 'US-OBD-00748  05/21',
    },
    17: {
        // NMIBC
        id: 17,
        jobCode: 'US-NMI-00916 03/26',
    },
    18: {
        // GASTRIC
        id: 18,
        jobCode: 'US-OGA-01033 12/25',
    },
    19: {
        // ESO
        id: 19,
        jobCode: 'US-ESO-00279 06/26',
    },
    20: {
        // CHL
        id: 20,
        jobCode: 'US-PDO-02578 07/25',
    },
    21: {
        // PMBCL
        id: 21,
        jobCode: 'US-PDO-02579 07/25',
    },
    22: {
        // MSI-H
        id: 22,
        jobCode: 'US-OVA-01039 12/25',
    },
    23: {
        // CRC
        id: 23,
        jobCode: 'US-OVC-01131 12/25',
    },
    24: {
        // CERVICAL
        id: 24,
        jobCode: 'US-CES-00022 04/26',
    },
    25: {
        // TMB-H
        id: 25,
        jobCode: 'US-TMB-00085 05/23',
    },
    26: {
        // TNBC
        id: 26,
        jobCode: 'US-OBS-00071 08/26',
    },
    // not sure if these will continue to have their own job codes or if it will be a part of MT submission in the future
    27: {
        // ALL Biomarker pages
        id: 27,
        jobCode: 'US-PDS-00798 06/26',
    },
    28: {
        // MSI-H Biomarker
        // id: 28,
        // jobCode: 'US-KEY-06845 06/23',
    },
    29: {
        // TMB-H Biomarker
        // id: 29,
        // jobCode: 'US-TMB-00081 07/22',
    },
    30: {
        // MT DOSING
        id: 30,
        jobCode: 'US-KEY-10707 08/26',
    },
    31: {
        // RESOURCES (RESOURCE CENTER + MOA + KEY+YOU)
        id: 31,
        jobCode: 'US-KEY-10302 12/25',
    },
    32: {
        // ENDO
        id: 32,
        jobCode: 'US-ENS-00018 03/26',
    },
    33: {
        // RCC (advanced)
        id: 33,
        jobCode: 'US-RCC-01090 12/25',
    },
    34: {
        // Dose Modifications, Admin & Prep
        id: 34,
        jobCode: 'US-KEY-10655 06/26',
    },
    35: {
        // AA Dosing
        id: 35,
        jobCode: 'US-KEY-06174 01/23',
    },
    36: {
        // Biliary
        id: 36,
        jobCode: 'US-KEB-00110 12/25',
    },
    37: {
        // HNSCC squamous
        id: 37,
        jobCode: 'US-OHS-00022 07/26',
    },
   38: {
        // qlex landing page
        id: 38,
        jobCode: 'US-PDS-01180 09/26',
    },
    39:{
        //indication ESIT
        id: 39,
        jobCode: 'US-KEY-10299 12/25',
    },
    41:{
        //MIBC
        id: 41,
        jobCode: 'US-MIB-00321 08/26',
    },    
    40:{
        //positive GAS
        id: 40,
        jobCode: 'US-OGS-00009 02/26'
    },
    42:{
        //Ovarian
        id: 42,
        jobCode: 'US-VAS-00003 04/26',
    },
    43:{
        // ASCO resource
        id: 43,
        jobCode: 'US-PDS-00792 05/26',
    },
};